import React from "react";
import Icon from "./AppIcon";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    error.__ErrorBoundary = true;
    window.__COMPONENT_ERROR__?.(error, errorInfo);
    // console.log("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state?.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
          <div className="w-full max-w-lg rounded-[28px] border border-white/10 bg-card/95 p-8 shadow-[0_24px_80px_rgba(0,0,0,0.35)]">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-warning/20 bg-warning/10 text-warning">
              <Icon name="AlertTriangle" size={22} />
            </div>

            <div className="text-center">
              <p className="text-xs uppercase tracking-[0.28em] text-muted-foreground">Portal Recovery</p>
              <h1 className="mt-3 text-2xl font-semibold text-foreground">This page hit an unexpected error.</h1>
              <p className="mt-3 text-sm leading-6 text-muted-foreground">
                Reload this page first. If the issue continues, return to the portal home page and try the action again.
              </p>
            </div>

            <div className="mt-6 grid gap-3 sm:grid-cols-2">
              <button
                onClick={() => {
                  window.location.reload();
                }}
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:brightness-110"
              >
                <Icon name="RefreshCw" size={16} color="#fff" />
                Reload Page
              </button>
              <button
                onClick={() => {
                  window.location.href = "/";
                }}
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/10 bg-transparent px-4 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-muted/40"
              >
                <Icon name="ArrowLeft" size={16} />
                Return Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props?.children;
  }
}

export default ErrorBoundary;
